module.exports = __webpack_public_path__ + "sansg/img/ena.44efd9da.png";